export enum SchemaName {
  Admin = 'admin',
  Builder = 'builder_',
  Subbie = 'subbie',
  ItpSubbie = 'itp_subbie',
  SupplierInsights = 'supplier_insights',
}
